export const convertStringToStyleObject = (styles) => {
  if (!styles) {
    return ''
  }

  return styles
    .replace(/\s*/g, '')
    .split(';')
    .filter((s) => s && s.split(':').length === 2)
    .reduce((acc, s) => {
      const [key, value] = s.split(':')

      if (key && value) {
        acc[key] = value
      }

      return acc
    }, {})
}